var React = require('react');

function EmptyProfile (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#DF3FAF;}\n"),React.createElement("path",{"className":"st0","d":"M102.7,105.5h-67l0.8-3.4c1.6-7.7,5.7-14.7,11.7-19.9C60,71.8,77.6,71.7,89.7,81.8c5.4,4.4,9.3,10.3,11.2,17\n\tC101.6,100.9,102.1,103.2,102.7,105.5z M93.4,98.6c-3.3-9.3-13.2-18.1-25.9-17.3C55.7,82,47.3,91.1,44.9,98.6H93.4z","key":1}),React.createElement("path",{"className":"st0","d":"M69.2,31.2c10.8,0,19.6,8.8,19.6,19.7S80,70.5,69.1,70.5c-10.8,0-19.6-8.8-19.6-19.6S58.3,31.3,69.2,31.2z\n\t M69.2,63.5c7,0,12.7-5.7,12.7-12.7s-5.7-12.7-12.7-12.7s-12.7,5.7-12.7,12.7l0,0C56.5,57.9,62.1,63.5,69.2,63.5L69.2,63.5z","key":2})]);
}

EmptyProfile.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 141 141","style":{"enableBackground":"new 0 0 141 141"},"xmlSpace":"preserve"};

module.exports = EmptyProfile;

EmptyProfile.default = EmptyProfile;
